export const byNewest = (a, b) => String(b.publishedAt).localeCompare(String(a.publishedAt));

const episodeNumber = (post) => Number(post?.audio?.episodeNumber ?? Number.MAX_SAFE_INTEGER);

export const byEpisodeNumber = (a, b) => episodeNumber(a) - episodeNumber(b) || byNewest(a, b);

export const hasAudio = (post) => Boolean(post?.audio?.url);

/**
 * The title a list shows. Posts may carry a keyword-heavy `title` for the page
 * and its <title>/RSS entry, plus a `shortTitle` for cards and rows — without
 * it, two sibling episodes repeat the same prefix all the way down a list.
 */
export const listTitle = (post) => post?.shortTitle || post?.title || '';

export const getTags = (post) => post?.tags ?? [];

const TAG_TITLES = {
  'exam-day': 'Exam Day',
  'getting-started': 'Getting Started',
  motivation: 'Motivation',
  podcast: 'Podcast',
  practice: 'Practice',
  speaking: 'Speaking',
};

export const tagTitle = (tag = '') =>
  TAG_TITLES[tag] ??
  tag
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getRelatedPosts = (post, allPosts = [], limit = 2) => {
  if (!post) return [];

  const explicit = (post.related ?? []).map((id) => allPosts.find((entry) => entry.id === id)).filter(Boolean);

  const siblings = allPosts.filter(
    (entry) =>
      entry.groupId === post.groupId && entry.id !== post.id && !explicit.some((chosen) => chosen.id === entry.id),
  );

  return [...explicit, ...siblings].slice(0, limit);
};

export const findRelatedEpisode = (post, allPosts = []) =>
  (post?.related ?? []).map((id) => allPosts.find((entry) => entry.id === id)).find(hasAudio) ?? null;

export const formatDuration = (seconds = 0) => {
  const totalMinutes = Math.round(seconds / 60);
  if (totalMinutes < 60) return `${totalMinutes} min`;
  const hours = Math.floor(totalMinutes / 60);
  return `${hours} h ${String(totalMinutes % 60).padStart(2, '0')}`;
};

export const toIsoDuration = (seconds = 0) =>
  `PT${Math.floor(seconds / 60)}M${String(Math.floor(seconds % 60)).padStart(2, '0')}S`;

export const readingMinutes = (post) => Math.max(1, Math.round(Number(post?.readingMinutes ?? post?.readMinutes) || 1));

export const metaLabel = (post) =>
  hasAudio(post) ? formatDuration(post.audio.durationSeconds) : `${readingMinutes(post)} min read`;
